module.exports = __webpack_public_path__ + "static/media/profile-placeholder-m.86537cc8.png";